import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Row card for lists (carpool row, etc.) — uses `.page-list-card` from PageShell.
 */
function PageListCard({ to, icon, title, meta, trailing, className = '' }) {
  return (
    <Link to={to} className={`page-list-card${className ? ` ${className}` : ''}`}>
      {icon != null && (
        <span className="page-list-card__icon" aria-hidden>
          {icon}
        </span>
      )}
      <div className="page-list-card__body">
        <span className="page-list-card__name">{title}</span>
        {meta != null && meta !== '' && <span className="page-list-card__meta">{meta}</span>}
      </div>
      {trailing}
    </Link>
  );
}

export default PageListCard;
